$(document).ready(function(){

function initializeModal() {
  // Store the last focused element before opening the modal
  let lastFocusedElement;

  // When the trigger button is clicked
  $('.qview').click(function(e) {
    var modalClass = $(this).data('modal');
    var modal = $('.' + modalClass);

    // Save the currently focused element
    lastFocusedElement = document.activeElement;

    // Show the modal and focus on it
    modal.css('visibility', 'visible').hide().fadeIn(100);
    modal.attr('tabindex', '-1').focus();
  });

  // If close button is clicked
  $('.modalwindow .modal-close').click(function(e) {
    // Cancel the link behavior
    e.preventDefault();
    $(this).closest('.modalwindow').fadeOut(100);
    
    // Return focus to the last focused element
    lastFocusedElement.focus();
  });

  // Hide modal if clicked outside modal content
  $('.modalwindow').on('click', function(e) {
    if (e.target !== this) return;
    $(this).fadeOut();

    // Return focus to the last focused element
    lastFocusedElement.focus();
  });

  // Close modal with the Escape key
  $(document).on('keydown', function(e) {
    if (e.key === "Escape") {
      $('.modalwindow').fadeOut(100);
      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }
    }
  });
}

// Initialize all modals
initializeModal();

      

function initializeSlideshows() {
  $('.product-option-pics').each(function() {
    var currentIndex = 0;
    var slideshowContainer = $(this).find('.photo-slide-container');
    var slides = slideshowContainer.find('.photo-slide');
    
    // Initialize by showing only the first slide
    slides.hide();
    slides.eq(currentIndex).show();

    // Function to show a specific slide
    function showSlide(index) {
      slides.hide();
      slides.eq(index).fadeIn(300); // Transition effect
    }

    // Click event for Next button
    $(this).find('.slide-right').click(function() {
      currentIndex = (currentIndex + 1) % slides.length; // Loop to first slide if at end
      showSlide(currentIndex);
    });

    // Click event for Prev button
    $(this).find('.slide-left').click(function() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length; // Loop to last slide if at start
      showSlide(currentIndex);
    });
  });
}

// Initialize all slideshows
initializeSlideshows();

         $('.product-option-pics-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows:true,
        infinite:true,
        focusOnSelect: true,
        vertical: false
      });   
       $('.qview').click(function(e) {
               $('.product-option-pics-2').slick("slickGoTo", 0);
        });

});
